// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCSFC9mdPJ3DDmjzgbnRK8N-iXMjCwb2W0",
  authDomain: "datyabayatz.firebaseapp.com",
  projectId: "datyabayatz",
  storageBucket: "datyabayatz.firebasestorage.app",
  messagingSenderId: "188598565986",
  appId: "1:188598565986:web:012daa17fcc7669b36253b",
  measurementId: "G-PYS95Q6RDZ"
};

const products_col_name = "products";
const categories_col_name = "categories";
const promotions_col_name = "promotions";
const contact_infos_col_name = "contact_infos";
const adverts_col_name = "adverts";
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth(app);
const db = getFirestore(app);


export { app,auth,db,products_col_name,categories_col_name,promotions_col_name,contact_infos_col_name};